import { queryOptions, useQuery } from "@tanstack/react-query";
import bomItemService from "../services/bom-item-service";

export const bomItemsQueryOptions = () =>
    queryOptions({
        queryKey: ["bom-items"],
        queryFn: () => bomItemService.list(),
        staleTime: 1000 * 60 * 60,
    });

export const useBomItems = () => useQuery(bomItemsQueryOptions());

export const useBomItemsOptions = () => {
    const query = useBomItems();
    const options = (query.data ?? []).map((item) => ({
        value: item.item_name,
        label: item.item_name,
    }));
    return { ...query, options };
};
